import {BaseComparisonOperator} from '../base-comparison-operator';
import {Check} from "@sparkware/app-utils";
import {ILoggerService} from '../../../../../logger/logger.service.interface';

export class LessThanOperator extends BaseComparisonOperator {
    constructor(private _logger: ILoggerService) {
        super();
    }

    compare(value1: unknown, value2: unknown): boolean {
        if (!Check.isNumber(value1) || !Check.isNumber(value2)) {
            this._logger.error(`Less Than Operator: Values should be numbers! value1=${value1}; value2=${value2}`);
        }
        return value1 < value2;
    }
}
